import styled from '@emotion/styled';
import { MoodysLogoComponent } from '@risk-first/ui-assets';
import { themeGet } from '@risk-first/ui-style-utils';

export const MoodysLogo = styled(MoodysLogoComponent)`
  fill: ${themeGet('colors.white')};
`;

export const ProductLogo = styled.h2`
  color: ${themeGet('colors.white')};
  font-size: 1.5rem;
  font-weight: 600;
`;
